(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('UserLine', UserLineClass);

  function UserLineClass() {

    function UserLine(lineType, label, lineName){
      if (!(this instanceof UserLine)) return new UserLine(lineType, label, lineName);

      this.lineType = lineType;
      this.label = label;
      this.lineName = lineName;
    }

    _.extend(UserLine.prototype, {
      getLineType: function () {
        return this.lineType;
      },
      getLabel: function () {
        return this.label;
      },
      getLineName: function () {
        return this.lineName;
      }
    });

    return UserLine;

  }

}());